module.exports = __webpack_public_path__ + "static/media/054-bold-menu.91f551a1.svg";